import * as React from 'react';
import { format } from 'date-fns';
import NextImage from 'next/image';
import { Author } from 'constants/blog';
import { getArticlePageUrl } from 'constants/pages';
import Link from 'components/Link';
import Tag from 'components/blog/Tag';
import classNames from 'styles/utils/classNames';

interface Props {
  title: string;
  image: string;
  author: Author;
  previewText: string;
  createdAt: string;
  tags: string[];
  id: string;
  slug?: string;
}

export default function Post(props: Props) {
  const { image, title, createdAt, tags, author, previewText, id, slug } = props;

  return (
    <Link href={getArticlePageUrl(slug || '')}>
      <div className="flex h-full border-spacing-6 flex-col rounded-xl ring-2 ring-color-bg-lightmode-primary ring-offset-8 ring-offset-color-bg-lightmode-primary hover:ring-color-bg-lightmode-invert dark:ring-color-bg-darkmode-primary dark:ring-offset-color-bg-darkmode-primary hover:dark:ring-color-bg-darkmode-invert">
        <NextImage
          src={image}
          alt={title}
          className="h-[13.75rem] w-full rounded-lg object-cover object-center"
          loading="lazy"
          height={220}
          width={352}
        />
        <div className="mt-ds-lg flex-grow">
          <span className="typography-product-element-label text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            {author?.name} • {format(new Date(createdAt), 'd LLL yyyy')}
          </span>
          <h2 className="typography-product-heading-compact mb-2 mt-1 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {title}
          </h2>
          <p
            className={classNames(
              'typography-product-caption mb-3 mt-0 line-clamp-3 text-color-text-lightmode-placeholder dark:text-color-text-darkmode-placeholder',
            )}
          >
            {previewText}
          </p>
        </div>
        <div className="mt-auto">
          {tags?.map((tag: string, index) => (
            <Tag
              text={tag}
              key={index}
              appendClasses={false}
              className={
                'typography-product-button-label-small mr-2 inline-block rounded-full bg-color-bg-lightmode-tertiary px-3 py-1 text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-tertiary dark:text-color-text-darkmode-secondary'
              }
            />
          ))}
        </div>
      </div>
    </Link>
  );
}
